import { render } from "./inputFile.component.vue?vue&type=template&id=0649feef&ts=true"
import script from "./inputFile.component.vue?vue&type=script&lang=ts"
export * from "./inputFile.component.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/SMSFrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__